import React from 'react';
import  LiquidationResult  from './LiquidationResult';
import ProfitLossResult from './ProfitLossResult';
import CryptoConversionResult from './CryptoConversionResult';
import StakingRewardResult from './StakingRewardResult';
import HoldingRewardsResult from './HoldingRewardsResult';
import ExchangeFeeResult from './ExchangeFeeResult';
import DCABasicResult from './DCABasicResult';
import DCAHistoricalResult from './DCAHistoricalResult';
import DCAPositionResult from './DCAPositionResult';


const DefaultResult = ({ result }) => (
  <div className="rounded-xl p-6 shadow-lg bg-white dark:bg-zinc-900 mt-6" id="result-block">
    <h2 className="text-xl font-semibold mb-4">Result</h2>
    <pre className="text-sm text-gray-700 dark:text-gray-200">
      {JSON.stringify(result, null, 2)}
    </pre>
  </div>
);

const RenderBlock = ({ calculatorId, result }) => {
  if (!result) return null;




  switch (calculatorId) {
    case 'liquidation':
      return <LiquidationResult result={result} />;
    case 'basic_dca':
      return <DCABasicResult result={result} />;
    case 'dcah':
      return <DCAHistoricalResult result={result} />;
    case 'dcap':
      return <DCAPositionResult result={result} />;
    case 'plcalc':
      return <ProfitLossResult result={result} />;
    case 'crypto':
      return <CryptoConversionResult result={result} />;
    case 'stakingr':
      return <StakingRewardResult result={result} />;
    case 'holdingr':
      return <HoldingRewardsResult result={result} />;
      case 'fees':
        return <ExchangeFeeResult result={result} />;
    default:
      return <DefaultResult result={result} />;
  }
};

export default RenderBlock;
